import { render, staticRenderFns } from "./staffSummary.vue?vue&type=template&id=68b0726c&"
import script from "./staffSummary.vue?vue&type=script&lang=js&"
export * from "./staffSummary.vue?vue&type=script&lang=js&"
import style0 from "./staffSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports